import React from 'react';
import { Form, Formik } from 'formik';
import { Flex } from '@zillow/constellation';
import { useLocation } from 'react-router-dom';
import {
  ShortcutData,
  useGetCustomViewsQuery,
  useSetCustomViewsMutation,
} from '../../../../../API/pcDashboard/CustomViewsApi';
import { checkForMutationSuccess } from '../../../../../API/checkForMutationSuccess';
import { NameField } from './customViewFields/NameField';
import { KeyboardKeyField } from './customViewFields/KeyboardKeyField';
import { UrlSearchStringField } from './customViewFields/UrlSearchStringField';
import { DescriptionField } from './customViewFields/DescriptionField';
import { useCustomViewsContext } from '../context/CustomViewsContext';
import { useGenerateCustomViewValidation } from './useGenerateCustomViewValidation';
import { v4 as uuid } from 'uuid';
import { UUID } from '../../../../../types/shared/UUID';
import { CustomViewsStateAndFormikContextConduit } from '../context/CustomViewsState';

const generateUniqueId = (data: Record<UUID, ShortcutData>): UUID => {
  let id = uuid();
  while (id in data) {
    id = uuid();
  }
  return id;
};

export const NewCustomViewForm: React.FC = () => {
  const { search } = useLocation();
  const { data = {} } = useGetCustomViewsQuery();
  const [setCustomViews] = useSetCustomViewsMutation();
  const { resetContext } = useCustomViewsContext();
  const validationSchema = useGenerateCustomViewValidation();

  return (
    <Formik
      initialValues={{ name: '', keyboardKey: '', search, description: '' }}
      onSubmit={async ({ name, keyboardKey, search, description }) => {
        const id = generateUniqueId(data);
        const response = await setCustomViews({ ...data, [id]: { id, name, keyboardKey, search, description } });
        if (checkForMutationSuccess(response, 'creating custom view')) {
          resetContext();
        }
      }}
      validationSchema={validationSchema}
    >
      <Form id={'new-custom-view-form'}>
        <Flex display={'flex'} flexDirection={'column'} gap={'xs'}>
          <CustomViewsStateAndFormikContextConduit />
          <NameField />
          <KeyboardKeyField />
          <UrlSearchStringField />
          <DescriptionField />
        </Flex>
      </Form>
    </Formik>
  );
};
